export const moveElToLeftIfHidden = (
  offset: number,
  el: HTMLElement | null
) => {
  if (!el) return;
  const { x, width } = el.getBoundingClientRect();
  const hiddenWidth = x + width + offset - window.innerWidth;
  if (hiddenWidth > 0) {
    el.style.left = `-${hiddenWidth}px`;
  }
};
